

























import { Component, Vue } from "vue-property-decorator";

@Component
class IconRefresh extends Vue {
  get colors() {
    return [this.$vuetify.theme.currentTheme.grayscale_1];
  }
}
export default IconRefresh;
